import { render, staticRenderFns } from "./RoomPage.vue?vue&type=template&id=83e1753c&scoped=true"
import script from "./RoomPage.vue?vue&type=script&lang=js"
export * from "./RoomPage.vue?vue&type=script&lang=js"
import style0 from "./RoomPage.vue?vue&type=style&index=0&id=83e1753c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e1753c",
  null
  
)

export default component.exports